/* Progressive enhancement only: product content and native links come from Liquid. */
(() => {
  'use strict';
  const root = document.getElementById('wcc-home');
  if (!root || root.dataset.initialized) return;
  const $ = selector => root.querySelector(selector);
  const grid = $('#products');
  const count = $('#result-count');
  const search = $('#search');
  const sort = $('#sort');
  const dialog = $('#detail');
  if (!grid || !count || !search || !sort || !dialog) return;
  root.dataset.initialized = 'true';
  const bottleGroups = ['scotch-whisky', 'gin', 'bourbon', 'cognac', 'vodka'];
  const handles = { 'Scotch Whisky': 'scotch-whisky', Gin: 'gin', Bourbon: 'bourbon', Cognac: 'cognac', Vodka: 'vodka' };
  let filter = 'Bottles';
  let opener = null;

  function watchImage(image) {
    if (image.dataset.watched) return;
    image.dataset.watched = 'true';
    const stage = image.parentElement;
    const fallback = stage.querySelector('.image-fallback');
    stage.classList.add('is-loading');
    const loaded = () => {
      if (image.parentElement !== stage) return;
      stage.classList.remove('is-loading');
      stage.removeAttribute('aria-busy');
    };
    const failed = () => {
      if (image.parentElement !== stage) return;
      loaded();
      image.hidden = true;
      if (fallback) fallback.hidden = false;
      stage.classList.add('image-failed');
    };
    stage.setAttribute('aria-busy', 'true');
    image.addEventListener('load', loaded, { once: true });
    image.addEventListener('error', failed, { once: true });
    if (image.complete) {
      if (image.naturalWidth > 0) loaded();
      else failed();
    }
  }
  root.querySelectorAll('[data-managed-image]').forEach(watchImage);

  let products;
  try {
    products = [...grid.querySelectorAll('[data-product-json]')].map((card, index) => {
      const product = JSON.parse(card.dataset.productJson);
      if (typeof product.id !== 'string' || typeof product.title !== 'string' ||
          typeof product.handle !== 'string' || !Array.isArray(product.memberships) ||
          !Array.isArray(product.categories) || !Array.isArray(product.variants) ||
          !Number.isFinite(product.price)) throw new Error('Invalid catalogue data');
      return { ...product, card, index };
    });
  } catch (_) {
    count.textContent = 'Browse the catalogue below. Search is temporarily unavailable.';
    return; // Leave every server-rendered card and native link usable.
  }

  const isBottle = product => product.memberships.some(handle => bottleGroups.includes(handle));
  function matches(product) {
    if (filter === 'All') return true;
    if (filter === 'Bottles') return isBottle(product);
    if (filter === 'Accessories') return !isBottle(product) && !product.isCask;
    if (filter === 'Spirits') return isBottle(product) && !product.memberships.includes('scotch-whisky');
    return product.memberships.includes(handles[filter]);
  }
  function render() {
    const query = search.value.toLocaleLowerCase().trim();
    const ordered = [...products];
    if (sort.value === 'low') ordered.sort((a, b) => a.price - b.price || a.index - b.index);
    if (sort.value === 'high') ordered.sort((a, b) => b.price - a.price || a.index - b.index);
    if (sort.value === 'az') ordered.sort((a, b) => a.title.localeCompare(b.title));
    let visible = 0;
    const fragment = document.createDocumentFragment();
    ordered.forEach(product => {
      const show = matches(product) && [product.title, ...product.categories].join(' ').toLocaleLowerCase().includes(query);
      product.card.hidden = !show;
      if (show) visible += 1;
      fragment.append(product.card);
    });
    grid.append(fragment);
    $('#empty-results').hidden = visible !== 0;
    root.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === filter)));
    $('#collection-title').textContent = filter === 'Accessories' ? 'For your whisky table' : filter === 'All' ? 'The full catalogue' : filter === 'Spirits' ? 'Distinctive spirits' : 'The bottle collection';
    count.textContent = visible + (visible === 1 ? ' selection' : ' selections');
  }

  function open(product, trigger) {
    if (!product || typeof dialog.showModal !== 'function') return false;
    const link = product.card.querySelector('h3 a');
    const url = new URL(link.getAttribute('href'), location.href);
    if (url.origin !== location.origin || !/^\/products\/[^/]+$/.test(url.pathname)) return false;
    $('#detail-title').textContent = product.title;
    $('#detail-category').textContent = product.category;
    $('#detail-price').textContent = product.priceText;
    $('#detail-description').textContent = product.description;
    $('#detail-availability').textContent = product.available ? '' : 'Currently unavailable';
    $('#detail-link').setAttribute('href', url.pathname);
    const stage = product.card.querySelector('.image-stage');
    const imageArea = $('#detail-image');
    imageArea.replaceChildren();
    imageArea.classList.remove('is-loading', 'image-failed');
    imageArea.removeAttribute('aria-busy');
    const image = stage.querySelector('img');
    if (image && !image.hidden) {
      const copy = image.cloneNode(true);
      copy.removeAttribute('data-watched');
      copy.removeAttribute('loading');
      copy.removeAttribute('sizes');
      const fallback = document.createElement('div');
      fallback.className = 'no-image image-fallback';
      fallback.hidden = true;
      fallback.textContent = 'Image unavailable';
      imageArea.append(copy, fallback);
      watchImage(copy);
    } else {
      const fallback = stage.querySelector('.no-image');
      if (fallback) {
        const copy = fallback.cloneNode(true);
        copy.hidden = false;
        imageArea.append(copy);
      }
    }
    opener = trigger;
    try {
      if (!dialog.open) dialog.showModal();
      $('#detail-close').focus();
      return true;
    } catch (_) { return false; } // Native anchor navigation remains the fallback.
  }

  root.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-filter]');
    if (button) { filter = button.dataset.filter; render(); }
    const nav = event.target.closest('[data-nav]');
    if (nav) { filter = nav.dataset.nav; search.value = ''; render(); }
    const trigger = event.target.closest('[data-open], [data-feature]');
    if (trigger && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.altKey && !event.shiftKey) {
      const product = trigger.hasAttribute('data-feature') ? products.find(p => p.handle === 'mac-talla-strata') : products.find(p => p.id === trigger.dataset.open);
      if (open(product, trigger)) event.preventDefault();
    }
    if (event.target.closest('#reset')) { filter = 'Bottles'; search.value = ''; render(); }
  });
  search.addEventListener('input', render);
  sort.addEventListener('change', render);
  $('#search-clear').addEventListener('click', () => { search.value = ''; render(); search.focus(); });
  $('#search-toggle').addEventListener('click', () => {
    const visible = $('#search-row').classList.toggle('open');
    $('#search-toggle').setAttribute('aria-expanded', String(visible));
    if (visible) { location.hash = 'collection'; search.focus(); }
  });
  $('#detail-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { if (opener && opener.isConnected) opener.focus({ preventScroll: true }); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  render();
  root.classList.add('is-enhanced');
  root.querySelectorAll('[data-enhance-only]').forEach(element => { element.hidden = false; });
})();
